import React, { useRef, useState } from 'react'
import {
  CCard,
  CCardBody,
  CCardHeader,
  CCol,
  CForm,
  CFormInput,
  CRow,
  CTableHeaderCell,
  CLoadingButton,
  CTableRow,
  CFormSelect,
  CFormLabel,
  CMultiSelect,
  CFormTextarea,
  CButton,
  CAccordion,
  CAccordionItem,
  CAccordionHeader,
  CAccordionBody,
  CInputGroup,
  CInputGroupText,
  CHeaderNav,
  CButtonGroup,
  CTooltip,
  CLink,
} from '@coreui/react-pro'
import Bootbox from 'bootbox-react'
import moment from 'moment'
import { cilFile, cilInfo, cilList, cilReload, cilSave } from '@coreui/icons'
import CIcon from '@coreui/icons-react'
import { useFormik } from 'formik'
import ToastComponent from 'src/components/common/TaostComponent'
import ScorecardService from 'src/service/ScorecardService'
import CompleteMarkModal from './CompleteMarkModal'
import { Link } from 'react-router-dom'
import Loader from 'src/components/Loader'
import MarkAsCompleteModal from './MarkAsCompleteModal'
import LegendInfo from './LegendInfo'
const TeamCommonScorecard = (props) => {
  const formRef = useRef(null)
  const formik = useFormik({
    initialValues: {
      data: props.scorecardDetails,
      scorcard_link_name: props.fixtureDetails?.scorcard_link_name,
      scorcard_link_url: props.fixtureDetails?.scorcard_link_url,
      fall_of_wickets: props.fixtureDetails?.fall_of_wickets,
      match_report: props.fixtureDetails?.match_report,
      potm_match_status: props.fixtureDetails?.potm_match_status ?? 0,
      potm_match_status2: props.fixtureDetails?.potm_match_status2 ?? 0,
      potm: props.fixtureDetails?.potm ?? [], // for Team 1
      potm2: props.fixtureDetails?.potm2 ?? [], // for Team 2
      match_status: '',
    },
    enableReinitialize: true,
    onSubmit: (data, actions) => {
      props.setCommonScorecardLoading(true)
      data.fixtureId = props.fixtureId
      // data.potm = props.selectedValue
      data.status = props.statusValue
      data.inning = props.defaultInning
      data.paramTeamId = props.teamId
      props.setLoader(true)
      ScorecardService.saveScorecard(data).then((res) => {
        if (res.status === 200) {
          props.setCommonScorecardLoading(false)
          props.fetchData(props.defaultInning)
          ToastComponent(res.message, 'success')
        }
      })
    },
  })

  const [showResetConfirm, setShowResetConfirm] = useState(false)
  const handleResetConfirm = () => {
    resetFixtureScorecard()
    return setShowResetConfirm(false)
  }
  const handleResetCancel = () => {
    return setShowResetConfirm(false)
  }
  const clearScorecard = () => {
    setShowResetConfirm(true)
    console.log('clear scorecard')
  }
  const resetFixtureScorecard = () => {
    const data = {}
    data.fixtureId = props.fixtureId
    data.inning = props.defaultInning
    ScorecardService.clearFixtureScorecard(data).then((res) => {
      if (res.status === 200) {
        props.setCommonScorecardLoading(false)
        props.fetchData()
        ToastComponent(res.message, 'success')
      }
    })
  }

  const handleOutsideButtonClick = () => {
    if (formRef.current) {
      formRef.current.dispatchEvent(new Event('submit')) // Trigger form submission
    }
  }
  const dropdownCol1 = [
    { key: 'go' },
    { key: 'gks' },
    { key: 'og' },
    { key: 'ast' },
    { key: 'ps' },
    { key: 'pm' },
  ]
  const dropdownCol2 = [
    { key: 'gcd' },
    { key: 'ycd' },
    { key: 'rcd' },
    { key: 'cst' },
    { key: 'p60' },
    { key: 'p60plus' },
  ]
  return props?.commonScorecardLoading ? (
    <Loader />
  ) : (
    <>
      <CForm className="row g-3" onSubmit={formik.handleSubmit}>
        <CRow>
          <CCol xs={12} md={3} className="pt-3 pb-2">
            <span>
              <b> Round</b>: {props.fixtureDetails.round}
            </span>
          </CCol>
          <CCol xs={12} md={3} className="pt-3 pb-2">
            <span>
              <b> Team</b>:&nbsp;
              {props.gameDetails?.game_type !== 1 &&
                ((props.fixtureDetails?.team == props.teamId && props.fixtureDetails?.team_name) ||
                  (props.fixtureDetails?.team2 == props.teamId &&
                    props.fixtureDetails?.team2_name))}
              {props.gameDetails?.game_type == 1 && props.fixtureDetails?.team_name}
            </span>
          </CCol>
          <CCol xs={12} md={3} className="pt-3 pb-2">
            <span>
              <b> Start Date/Time</b>: {moment(props.fixtureDetails.start_date).format('D.MM.YYYY')}
              {', '}
              {moment(props.fixtureDetails.start_time, ['HH:mm']).format('h:mma')}
            </span>
          </CCol>
          <CCol xs={12} md={3} className="pt-3 pb-2">
            <span>
              <b> End Date/Time</b>: {moment(props.fixtureDetails.end_date).format('D.MM.YYYY')}
              {', '}
              {moment(props.fixtureDetails.end_time, ['HH:mm']).format('h:mma')}
            </span>
          </CCol>

          {props.fixtureDetails?.match_type_name === '2-Day' && (
            <CCol xs={12} md={3} className="pt-3 pb-2">
              <CFormLabel className="fw-bold" htmlFor="Country">
                Inning
              </CFormLabel>
              <CFormSelect
                aria-label="select inning"
                name="inning"
                onChange={props.changeInning}
                className={
                  'form-control' +
                  (formik.errors.inning && formik.touched.inning ? ' is-invalid' : '')
                }
                value={props.defaultInning}
                id="inning"
              >
                <option value={1}>1st Innings</option>
                <option value={2}>2nd Innings</option>
              </CFormSelect>
            </CCol>
          )}

          {props.isMobile ? (
            <CCol xs={12}>
              <CCard className="mb-4">
                <CCardHeader>
                  <strong>
                    <strong>
                      {props.fixtureDetails.scorcard_link_url ? (
                        <Link to={props.fixtureDetails.scorcard_link_url} target="_blank">
                          Scorecard
                        </Link>
                      ) : (
                        'Scorecard'
                      )}
                    </strong>
                  </strong>
                  <CHeaderNav className="float-end">
                    <CButtonGroup aria-label="Theme switch">
                      <CButton color={'primary'} onClick={handleOutsideButtonClick} title="Save">
                        <CIcon icon={cilSave} />
                      </CButton>
                      <CButton
                        color={'success'}
                        href={`/manage-scores/team-players/${props.fixtureId}/${props.teamId}`}
                        title="Squad"
                      >
                        <CIcon icon={cilList} />
                      </CButton>
                      <CButton color={'warning'} onClick={props.handleInfoClick} title="Legend">
                        <CIcon icon={cilInfo} />
                      </CButton>
                    </CButtonGroup>
                  </CHeaderNav>
                </CCardHeader>
                <CCardBody>
                  {props.loader ? (
                    <Loader />
                  ) : (
                    <CAccordion alwaysOpen>
                      {props.scorecardDetails &&
                        props.scorecardDetails.map((item, key) => (
                          <CAccordionItem itemKey={key} key={key}>
                            <CAccordionHeader>{item.player_name}</CAccordionHeader>
                            <CAccordionBody>
                              <CRow className="mb-2">
                                <div className="col-md-2 col-sm">
                                  <CInputGroup className="mb-2">
                                    <CInputGroupText
                                      id="inputGroup-sizing-default"
                                      style={{ width: '135px' }}
                                    >
                                      Runs
                                    </CInputGroupText>
                                    <CFormInput
                                      name={`data[${key}]rs`}
                                      type={'number'}
                                      defaultValue={item.rs}
                                      onChange={formik.handleChange}
                                      className="col-sm-10"
                                      id="rs"
                                    />
                                  </CInputGroup>
                                </div>
                                <div className="col-md-2 col-sm">
                                  <CInputGroup className="mb-2">
                                    <CInputGroupText
                                      id="inputGroup-sizing-default"
                                      style={{ width: '135px' }}
                                    >
                                      Ball Faced
                                    </CInputGroupText>
                                    <CFormInput
                                      name={`data[${key}]bf`}
                                      type={'number'}
                                      defaultValue={item.bf}
                                      onChange={formik.handleChange}
                                      className="col-sm-10"
                                      id="bf"
                                    />
                                  </CInputGroup>
                                </div>

                                <div className="col-md-2 col-sm">
                                  <CInputGroup className="mb-2">
                                    <CInputGroupText
                                      id="inputGroup-sizing-default"
                                      style={{ width: '135px' }}
                                      type={'number'}
                                    >
                                      Fours
                                    </CInputGroupText>
                                    <CFormInput
                                      name={`data[${key}]fours`}
                                      defaultValue={item.fours}
                                      onChange={formik.handleChange}
                                      id="fours"
                                      type={'number'}
                                    />
                                  </CInputGroup>
                                </div>
                                <div className="col-md-2 col-sm">
                                  <CInputGroup className="mb-2">
                                    <CInputGroupText
                                      id="inputGroup-sizing-default"
                                      style={{ width: '135px' }}
                                    >
                                      Sixes
                                    </CInputGroupText>
                                    <CFormInput
                                      name={`data[${key}]sixes`}
                                      defaultValue={item.sixes}
                                      onChange={formik.handleChange}
                                      id="sixes"
                                      type={'number'}
                                    />
                                  </CInputGroup>
                                </div>
                                <div className="col-md-2 col-sm">
                                  <CInputGroup className="mb-2">
                                    <CInputGroupText
                                      id="inputGroup-sizing-default"
                                      style={{ width: '135px' }}
                                    >
                                      Overs
                                    </CInputGroupText>
                                    <CFormInput
                                      name={`data[${key}]overs`}
                                      defaultValue={item.overs}
                                      onChange={formik.handleChange}
                                      id="OVRS"
                                      type={'number'}
                                    />
                                  </CInputGroup>
                                </div>
                                <div className="col-md-2 col-sm">
                                  <CInputGroup className="mb-2">
                                    <CInputGroupText
                                      id="inputGroup-sizing-default"
                                      style={{ width: '135px' }}
                                    >
                                      Maidens
                                    </CInputGroupText>
                                    <CFormInput
                                      name={`data[${key}]mdns`}
                                      defaultValue={item.mdns}
                                      onChange={formik.handleChange}
                                      id="mdns"
                                      type={'number'}
                                    />
                                  </CInputGroup>
                                </div>
                                <div className="col-md-2 col-sm">
                                  <CInputGroup className="mb-2">
                                    <CInputGroupText
                                      id="inputGroup-sizing-default"
                                      style={{ width: '135px' }}
                                    >
                                      Runs Given
                                    </CInputGroupText>
                                    <CFormInput
                                      name={`data[${key}]run`}
                                      defaultValue={item.run}
                                      onChange={formik.handleChange}
                                      id="run"
                                      type={'number'}
                                    />
                                  </CInputGroup>
                                </div>
                                <div className="col-md-2 col-sm">
                                  <CInputGroup className="mb-2">
                                    <CInputGroupText
                                      id="inputGroup-sizing-default"
                                      style={{ width: '135px' }}
                                    >
                                      Wickets
                                    </CInputGroupText>
                                    <CFormInput
                                      name={`data[${key}]wks`}
                                      defaultValue={item.wks}
                                      onChange={formik.handleChange}
                                      id="wks"
                                      type={'number'}
                                    />
                                  </CInputGroup>
                                </div>
                                <div className="col-md-2 col-sm">
                                  <CInputGroup className="mb-2">
                                    <CInputGroupText
                                      id="inputGroup-sizing-default"
                                      style={{ width: '135px' }}
                                    >
                                      Catches
                                    </CInputGroupText>
                                    <CFormInput
                                      name={`data[${key}]cs`}
                                      defaultValue={item.cs}
                                      onChange={formik.handleChange}
                                      id="cs"
                                      type={'number'}
                                    />
                                  </CInputGroup>
                                </div>
                                <div className="col-md-2 col-sm">
                                  <CInputGroup className="mb-2">
                                    <CInputGroupText
                                      id="inputGroup-sizing-default"
                                      style={{ width: '135px' }}
                                    >
                                      Catches-WK
                                    </CInputGroupText>
                                    <CFormInput
                                      name={`data[${key}]cwks`}
                                      defaultValue={item.cwks}
                                      onChange={formik.handleChange}
                                      id="cwks"
                                      type={'number'}
                                    />
                                  </CInputGroup>
                                </div>
                                <div className="col-md-2 col-sm">
                                  <CInputGroup className="mb-2">
                                    <CInputGroupText
                                      id="inputGroup-sizing-default"
                                      style={{ width: '135px' }}
                                    >
                                      Stumpings
                                    </CInputGroupText>
                                    <CFormInput
                                      name={`data[${key}]sts`}
                                      defaultValue={item.sts}
                                      onChange={formik.handleChange}
                                      id="sts"
                                      type={'number'}
                                    />
                                  </CInputGroup>
                                </div>

                                <div className="col-md-2 col-sm">
                                  <CInputGroup className="mb-2">
                                    <CInputGroupText
                                      id="inputGroup-sizing-default"
                                      style={{ width: '135px' }}
                                    >
                                      Run-Out Direct
                                    </CInputGroupText>
                                    <CFormInput
                                      name={`data[${key}]rods`}
                                      defaultValue={item.rods}
                                      onChange={formik.handleChange}
                                      id="rods"
                                      type={'number'}
                                    />
                                  </CInputGroup>
                                </div>
                                <div className="col-md-2 col-sm">
                                  <CInputGroup className="mb-2">
                                    <CInputGroupText
                                      id="inputGroup-sizing-default"
                                      style={{ width: '135px' }}
                                    >
                                      Run-Out Assist
                                    </CInputGroupText>
                                    <CFormInput
                                      name={`data[${key}]roas`}
                                      defaultValue={item.roas}
                                      onChange={formik.handleChange}
                                      id="roas"
                                      type={'number'}
                                    />
                                  </CInputGroup>
                                </div>
                                <div className="col-md-2 col-sm">
                                  <CInputGroup className="mb-2">
                                    <CInputGroupText
                                      id="inputGroup-sizing-default"
                                      style={{ width: '135px' }}
                                    >
                                      Duck
                                    </CInputGroupText>
                                    <CFormSelect
                                      id="dks"
                                      values={item.dks}
                                      name={`data[${key}]dks`}
                                      defaultValue={item.dks}
                                      onChange={formik.handleChange}
                                    >
                                      <option value={0}>No</option>
                                      <option value={1}>Yes</option>
                                    </CFormSelect>
                                  </CInputGroup>
                                </div>
                                <div className="col-md-2 col-sm">
                                  <CInputGroup className="mb-2">
                                    <CInputGroupText
                                      id="inputGroup-sizing-default"
                                      style={{ width: '135px' }}
                                    >
                                      Hat-Trick
                                    </CInputGroupText>
                                    <CFormSelect
                                      id="hattrick"
                                      values={item.hattrick}
                                      name={`data[${key}]hattrick`}
                                      defaultValue={item.hattrick}
                                      onChange={formik.handleChange}
                                    >
                                      <option value={0}>No</option>
                                      <option value={1}>Yes</option>
                                    </CFormSelect>
                                  </CInputGroup>
                                </div>
                                <div className="col-md-2 col-sm">
                                  <CInputGroup className="mb-2">
                                    <CInputGroupText
                                      id="inputGroup-sizing-default"
                                      style={{ width: '135px' }}
                                    >
                                      Not Out
                                    </CInputGroupText>
                                    <CFormSelect
                                      id="no"
                                      values={item.no}
                                      name={`data[${key}]no`}
                                      defaultValue={item.no}
                                      onChange={formik.handleChange}
                                    >
                                      <option value={0}>No</option>
                                      <option value={1}>Yes</option>
                                    </CFormSelect>
                                  </CInputGroup>
                                </div>
                                <div className="col-md-2 col-sm">
                                  <CInputGroup className="mb-2">
                                    <CInputGroupText
                                      id="inputGroup-sizing-default"
                                      style={{ width: '135px' }}
                                    >
                                      How Out
                                    </CInputGroupText>
                                    <CFormSelect
                                      id="hwot"
                                      values={item.hwot}
                                      name={`data[${key}]hwot`}
                                      defaultValue={item.hwot}
                                      onChange={formik.handleChange}
                                    >
                                      <option value={''}>Select Dismissal</option>
                                      <option value={'hobwl'}>Bowled</option>
                                      <option value={'hoct'}>Catch</option>
                                      <option value={'hocwk'}>Catch WK</option>
                                      <option value={'holbw'}>LBW</option>
                                      <option value={'host'}>Stump</option>
                                      <option value={'horod'}>RO-Direct</option>
                                      <option value={'horoa'}>RO-Assist</option>
                                      <option value={'hohw'}>Hit Wicket</option>
                                      <option value={'hohb'}>Handled-Ball</option>
                                      <option value={'hoobs'}>Obstruct</option>
                                      <option value={'hotmd'}>Timed</option>
                                    </CFormSelect>
                                  </CInputGroup>
                                </div>
                                <div className="col-md-2 col-sm">
                                  <CInputGroup className="mb-2">
                                    <CInputGroupText
                                      id="inputGroup-sizing-default"
                                      style={{ width: '135px' }}
                                    >
                                      WKT Bowled
                                    </CInputGroupText>
                                    <CFormInput
                                      name={`data[${key}]wb`}
                                      defaultValue={item.wb}
                                      onChange={formik.handleChange}
                                      id="wb"
                                      type={'number'}
                                    />
                                  </CInputGroup>
                                </div>
                                <div className="col-md-2 col-sm">
                                  <CInputGroup className="mb-2">
                                    <CInputGroupText
                                      id="inputGroup-sizing-default"
                                      style={{ width: '135px' }}
                                    >
                                      WKT Catch
                                    </CInputGroupText>
                                    <CFormInput
                                      name={`data[${key}]wct`}
                                      defaultValue={item.wct}
                                      onChange={formik.handleChange}
                                      id="wct"
                                      type={'number'}
                                    />
                                  </CInputGroup>
                                </div>
                                <div className="col-md-2 col-sm">
                                  <CInputGroup className="mb-2">
                                    <CInputGroupText
                                      id="inputGroup-sizing-default"
                                      style={{ width: '135px' }}
                                    >
                                      WKT Catch WK
                                    </CInputGroupText>
                                    <CFormInput
                                      name={`data[${key}]wcwk`}
                                      defaultValue={item.wcwk}
                                      onChange={formik.handleChange}
                                      id="wcwk"
                                      type={'number'}
                                    />
                                  </CInputGroup>
                                </div>
                                <div className="col-md-2 col-sm">
                                  <CInputGroup className="mb-2">
                                    <CInputGroupText
                                      id="inputGroup-sizing-default"
                                      style={{ width: '135px' }}
                                    >
                                      WKT LBW
                                    </CInputGroupText>
                                    <CFormInput
                                      name={`data[${key}]wlbw`}
                                      defaultValue={item.wlbw}
                                      onChange={formik.handleChange}
                                      id="wlbw"
                                      type={'number'}
                                    />
                                  </CInputGroup>
                                </div>
                                <div className="col-md-2 col-sm">
                                  <CInputGroup className="mb-2">
                                    <CInputGroupText
                                      id="inputGroup-sizing-default"
                                      style={{ width: '135px' }}
                                    >
                                      WKT Stump
                                    </CInputGroupText>
                                    <CFormInput
                                      name={`data[${key}]wst`}
                                      defaultValue={item.wst}
                                      onChange={formik.handleChange}
                                      id="wst"
                                      type={'number'}
                                    />
                                  </CInputGroup>
                                </div>
                                <div className="col-md-2 col-sm">
                                  <CInputGroup className="mb-2">
                                    <CInputGroupText
                                      id="inputGroup-sizing-default"
                                      style={{ width: '135px' }}
                                    >
                                      WKT Hit Wicket
                                    </CInputGroupText>
                                    <CFormInput
                                      name={`data[${key}]whw`}
                                      defaultValue={item.whw}
                                      onChange={formik.handleChange}
                                      id="whw"
                                      type={'number'}
                                    />
                                  </CInputGroup>
                                </div>
                                <div className="col-md-2 col-sm">
                                  <CInputGroup className="mb-2">
                                    <CInputGroupText
                                      id="inputGroup-sizing-default"
                                      style={{ width: '135px' }}
                                    >
                                      Dots Played
                                    </CInputGroupText>
                                    <CFormInput
                                      name={`data[${key}]dotp`}
                                      defaultValue={item.dotp}
                                      onChange={formik.handleChange}
                                      id="dotp"
                                      type={'number'}
                                    />
                                  </CInputGroup>
                                </div>
                                <div className="col-md-2 col-sm">
                                  <CInputGroup className="mb-2">
                                    <CInputGroupText
                                      id="inputGroup-sizing-default"
                                      style={{ width: '135px' }}
                                    >
                                      Dots Bowled
                                    </CInputGroupText>
                                    <CFormInput
                                      name={`data[${key}]dotb`}
                                      defaultValue={item.dotb}
                                      onChange={formik.handleChange}
                                      id="dotb"
                                      type={'number'}
                                    />
                                  </CInputGroup>
                                </div>

                                <div className="col-md-2 col-sm">
                                  <CInputGroup className="mb-2">
                                    <CInputGroupText
                                      id="inputGroup-sizing-default"
                                      style={{ width: '135px' }}
                                    >
                                      Fantasy Points
                                    </CInputGroupText>
                                    <CFormInput
                                      defaultValue={props.formatFantasyPoints(item.fantasy_points)}
                                      id="fantasy_points"
                                      disabled={true}
                                    />
                                  </CInputGroup>
                                </div>
                              </CRow>
                            </CAccordionBody>
                          </CAccordionItem>
                        ))}
                    </CAccordion>
                  )}
                </CCardBody>
              </CCard>
            </CCol>
          ) : (
            <CCol xs={12}>
              <CCard className="mb-4">
                <CCardHeader>
                  <strong>
                    {props.fixtureDetails.scorcard_link_url ? (
                      <Link to={props.fixtureDetails.scorcard_link_url} target="_blank">
                        Scorecard
                      </Link>
                    ) : (
                      'Scorecard'
                    )}
                  </strong>
                  <CHeaderNav className="float-end">
                    <CButtonGroup aria-label="Theme switch">
                      <CButton color={'primary'} onClick={handleOutsideButtonClick} title="Save">
                        <CIcon icon={cilSave} />
                      </CButton>

                      <CButton
                        color={'success'}
                        href={`/manage-scores/team-players/${props.fixtureId}/${props.teamId}`}
                        title="Squad"
                      >
                        <CIcon icon={cilList} />
                      </CButton>
                      <CButton color={'warning'} onClick={props.handleInfoClick} title="Legend">
                        <CIcon icon={cilInfo} />
                      </CButton>
                    </CButtonGroup>
                  </CHeaderNav>
                </CCardHeader>
                <CCardBody>
                  {props.loader ? (
                    <Loader />
                  ) : (
                    <div className="table-responsive" style={{ overflowX: 'auto' }}>
                      <table
                        className="main-table table innertable"
                        style={{ borderCollapse: 'collapse', width: '100%' }}
                      >
                        <thead>
                          <tr>
                            <th
                              style={{
                                position: 'sticky',
                                left: 0,
                                zIndex: 2,
                                backgroundColor: '#fff',
                                width: '150px', // Adjust width as needed
                              }}
                            >
                              PLAYER
                            </th>
                            <th>
                              <CTooltip content="Position">
                                <CLink> POS </CLink>
                              </CTooltip>
                            </th>
                            <th>
                              <CTooltip content="Fantasy Points">
                                <CLink> FP </CLink>
                              </CTooltip>
                            </th>
                            {props.scorecardColoumns.map((value, key) => (
                              <>
                                <th key={key}>
                                  <CTooltip content={value?.full_name}>
                                    <CLink> {value?.label} </CLink>
                                  </CTooltip>
                                </th>
                              </>
                            ))}
                          </tr>
                        </thead>
                        <tbody>
                          {props.scorecardDetails &&
                            props.scorecardDetails.map((item, key1) => (
                              <tr key={key1}>
                                <td
                                  style={{
                                    position: 'sticky',
                                    left: 0,
                                    zIndex: 1,
                                    backgroundColor: '#f9f9f9',
                                    width: '35px',
                                  }}
                                >
                                  {item.player_name}
                                </td>
                                <td>
                                  {item?.player_position == 1 ? 'GK' : ''}
                                  {item?.player_position == 2 ? 'DEF' : ''}
                                  {item?.player_position == 3 ? 'MID' : ' '}
                                  {item?.player_position == 4 ? 'FWD' : ''}
                                </td>
                                <td>
                                  <CFormInput
                                    defaultValue={props.formatFantasyPoints(item.fantasy_points)}
                                    id="fantasy_points"
                                    disabled={true}
                                    style={{ minWidth: '70px' }}
                                  />
                                </td>
                                {props.scorecardColoumns
                                  .filter((value) =>
                                    dropdownCol1.some(
                                      (dropdown) => dropdown.key === value?.attribute_key,
                                    ),
                                  )
                                  .map((value, key) => (
                                    <>
                                      <td>
                                        <CFormInput
                                          name={`data[${key1}]${value?.attribute_key}`}
                                          type={'number'}
                                          defaultValue={item[value?.attribute_key]}
                                          onChange={formik.handleChange}
                                          id={value?.attribute_key}
                                          style={{ minWidth: '70px' }}
                                        />
                                      </td>
                                    </>
                                  ))}
                                {props.scorecardColoumns
                                  .filter((value) =>
                                    dropdownCol2.some(
                                      (dropdown) => dropdown.key === value?.attribute_key,
                                    ),
                                  )
                                  .map((value, key) => (
                                    <>
                                      <td>
                                        <CFormSelect
                                          id={value?.attribute_key}
                                          values={item[value?.attribute_key]}
                                          name={`data[${key1}]${value?.attribute_key}`}
                                          defaultValue={item[value?.attribute_key]}
                                          onChange={formik.handleChange}
                                          style={{ minWidth: '70px' }}
                                        >
                                          <option value={0}>No</option>
                                          <option value={1}>Yes</option>
                                        </CFormSelect>
                                      </td>
                                    </>
                                  ))}
                              </tr>
                            ))}
                        </tbody>
                      </table>
                    </div>
                  )}
                </CCardBody>
              </CCard>
            </CCol>
          )}
          <CCol xs={12}>
            <CCard className="mb-4">
              <CCardHeader>
                <strong>Scorecard Details</strong>
              </CCardHeader>
              <CCardBody>
                <CRow>
                  <CCol md={6}>
                    <CFormLabel htmlFor="phone">Scorecard Source</CFormLabel>
                    <input
                      type="text"
                      name="scorcard_link_name"
                      className={'form-control'}
                      id="scorcard_link_name"
                      placeholder="Scorecard Source"
                      defaultValue={formik.values.scorcard_link_name}
                      onChange={(e) => props.handleInputChange(e, 'scorcard_link_name')}
                    />
                  </CCol>
                  <CCol md={6}>
                    <CFormLabel htmlFor="phone">Scorecard Link</CFormLabel>
                    <input
                      type="text"
                      name="scorcard_link_url"
                      className={'form-control'}
                      id="scorcard_link_url"
                      placeholder="Scorecard Link"
                      defaultValue={formik.values.scorcard_link_url}
                      onChange={(e) => props.handleInputChange(e, 'scorcard_link_url')}
                    />
                  </CCol>

                  <CCol md={6}>
                    <CFormLabel htmlFor="fall_of_wickets" className="mt-3">
                      Fall of Wickets
                    </CFormLabel>
                    <CFormTextarea
                      aria-label="With textarea"
                      defaultValue={formik.values.fall_of_wickets}
                      name={'fall_of_wickets'}
                      onChange={(e) => props.handleInputChange(e, 'fall_of_wickets')}
                    ></CFormTextarea>
                  </CCol>
                </CRow>
              </CCardBody>
            </CCard>
            <CompleteMarkModal visible={props.visible} setVisible={props.setVisible} />
          </CCol>
          <CCol xs={12}>
            <CCard className="mb-6">
              <CCardHeader>
                <strong>Bonus Points</strong>
              </CCardHeader>
              <CCardBody>
                <CRow>
                  <CCol md={6}>
                    <CFormLabel htmlFor="player_of_the_match">Player Of The Match</CFormLabel>

                    {/* Team 1 POTM */}
                    {props.fixtureDetails?.team == props.teamId &&
                      props.fixtureDetails?.team_name && (
                        <>
                          <label>&nbsp;for {props.fixtureDetails?.team_name}</label>
                          <CMultiSelect
                            id="potm"
                            name="potm"
                            options={props.playerList}
                            selectionType="tags"
                            onChange={(selected) => {
                              formik.setFieldValue(
                                'potm',
                                selected.map((s) => s.value),
                              )
                            }}
                            value={formik.values.potm
                              ?.map((val) => props.playerList.find((obj) => obj.value === val))
                              .filter(Boolean)}
                          />
                        </>
                      )}

                    {/* Team 2 POTM */}
                    {props.fixtureDetails?.team2 == props.teamId &&
                      props.fixtureDetails?.team2_name && (
                        <>
                          <label>&nbsp;for {props.fixtureDetails?.team2_name}</label>
                          <CMultiSelect
                            id="potm2"
                            name="potm2"
                            options={props.playerList.map((opt) => ({
                              ...opt,
                              selected: (formik.values.potm2 || []).includes(opt.value),
                            }))}
                            selectionType="tags"
                            onChange={(selected) => {
                              formik.setFieldValue(
                                'potm2',
                                selected.map((s) => s.value),
                              )
                            }}
                          />
                        </>
                      )}
                  </CCol>
                  <CCol md={6}>
                    <CFormLabel htmlFor="Match Result">Match Result</CFormLabel>
                    {/* Team 1 */}
                    {props.fixtureDetails?.team == props.teamId &&
                      props.fixtureDetails?.team_name && (
                        <>
                          <label>&nbsp;for {props.fixtureDetails?.team_name}</label>
                          <CFormSelect
                            id="potm_match_status"
                            name="potm_match_status"
                            value={formik.values.potm_match_status}
                            onChange={formik.handleChange}
                          >
                            <option>Select Match Result</option>
                            <option value="1">Won</option>
                            <option value="2">Other</option>
                          </CFormSelect>
                        </>
                      )}

                    {/* Team 2 */}
                    {props.fixtureDetails?.team2 == props.teamId &&
                      props.fixtureDetails?.team2_name && (
                        <>
                          <label>&nbsp;for {props.fixtureDetails?.team2_name}</label>
                          <CFormSelect
                            id="potm_match_status2"
                            name="potm_match_status2"
                            value={formik.values.potm_match_status2}
                            onChange={formik.handleChange}
                          >
                            <option>Select Match Result</option>
                            <option value="1">Won</option>
                            <option value="2">Other</option>
                          </CFormSelect>
                        </>
                      )}
                  </CCol>
                </CRow>
              </CCardBody>
            </CCard>
            <CompleteMarkModal visible={props.visible} setVisible={props.setVisible} />
          </CCol>

          <CCol xs={12}>
            <CCard className="mb-4">
              <CCardHeader>
                <strong>Save Scores</strong>
              </CCardHeader>
              <CCardBody>
                <CRow>
                  <CCol md={6}>
                    <CLoadingButton
                      type="submit"
                      color="success"
                      variant="outline"
                      loading={props.loader}
                      className="mt-3"
                    >
                      Press to Save
                    </CLoadingButton>
                  </CCol>
                </CRow>
              </CCardBody>
            </CCard>
          </CCol>
        </CRow>
      </CForm>
      <Bootbox
        show={showResetConfirm}
        type={'confirm'}
        message={'Are you sure you want to reset this?'}
        onSuccess={handleResetConfirm}
        onCancel={handleResetCancel}
        onClose={handleResetCancel}
      />
    </>
  )
}

export default TeamCommonScorecard
